<template>
<div class="row">
  <div class="column col-md-3">
    <label>{{ divisionName }}</label>
    <div>{{ model.DivisionName }}</div>
  </div>

  <div class="column col-md-3">
    <label>Invoice Total</label>
    <div><v-money :currency="model.CurrencyCode">{{ model.InvoiceTotalAmount }}</v-money></div>
  </div>
  
  <div class="column col-md-3">
    <label>Payments</label>
    <div><v-money :currency="model.CurrencyCode">{{ model.PaymentsAmount }}</v-money></div>
  </div>
  
  <div class="column col-md-3">
    <label>Balance</label>
    <div><v-money :currency="model.CurrencyCode">{{ model.Balance }}</v-money></div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    model: Object
  },

  computed: {
    divisionName() {
      return global.app.$user.$.settings.DivisionName || ''
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/font-awesome/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.column {
  @include theme {
  border-right: 1px solid v(background-light);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/components/InvoiceDetailsWithDivision.vue